module.exports = __webpack_public_path__ + "static/media/219401074_shad_saddlebag_liner_black_1 (1).b38e5e51.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/parts/images/219401074_shad_saddlebag_liner_black_1 (1).png
// module id = 486
// module chunks = 0